export default import.meta.ROLLDOWN_FILE_URL_pUayaLCC5cXfH2SWbpDFQg